var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 29,
    viewBox: "0 0 31 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.2525 27.715L1.2925 17.726C0.902501 17.33 0.902501 16.688 1.2925 16.292C1.5225 16.064 1.8225 15.983 2.1225 16.017L8.0225 16.017C8.0225 7.724 14.7425 0.999999 23.0325 0.999999C25.1625 0.999999 27.1825 1.448 29.0225 2.246C22.7625 3.431 18.0125 9.4 18.0125 16C18.3525 16 23.9025 16.017 23.9025 16.017C24.1925 15.983 24.5025 16.064 24.7225 16.292C24.7325 16.294 24.7325 16.298 24.7325 16.3C24.9225 16.482 25.0425 16.735 25.0425 17.019C25.0425 17.33 24.8925 17.597 24.6625 17.781L13.7725 27.715C13.5625 27.926 13.2825 28.016 13.0125 28.002C12.7325 28.016 12.4625 27.926 12.2525 27.715V27.715Z",
    stroke: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg3);
export default __webpack_public_path__ + "static/media/3.e583ae3cce2ed78b28a123de80d5a9df.svg";
export { ForwardRef as ReactComponent };